import React from 'react';
import { trackAddToCart } from './MetaPixel';
export const Header = () => {
  const handleBuyClick = (e: React.MouseEvent) => {
    trackAddToCart();
  };
  return <header className="bg-[#0C1B2A] text-white py-3 px-4 sm:px-6 flex flex-col sm:flex-row justify-between items-center" data-id="element-183">
      <p className="text-center sm:text-left text-sm font-medium mb-2 sm:mb-0" data-id="element-184">
        <span className="text-[#D4AF37] font-bold" data-id="element-185">¡OFERTA ESPECIAL!</span> •
        Garantía total de 7 días • Descarga inmediata
      </p>
      <a href="https://pay.hotmart.com/Y101890168S?checkoutMode=10" className="btn-purchase bg-[#D4AF37] hover:bg-[#C5A028] text-[#0C1B2A] font-bold text-sm py-2 px-4 rounded-md transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37]" aria-label="Comprar ahora por once dólares con noventa y nueve centavos" onClick={handleBuyClick} data-id="element-186">
        Comprar ahora — $11.99
      </a>
    </header>;
};